// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__28reE","productName":"Table_productName__36Oks"};